export { default } from './DetailBar';
